export class MediaSlickSlider {
    constructor(node, opts) {
        this.node = node;
        this.opts = {
            back: '.media-slider__back',
            forward: '.media-slider__forward',
            content: '.media-slider__slides',
            items: '.media-slider__slides > *',
            slides: '.dot',
            ...opts,
        };

        if (!this.node) {
            return;
        }

        this.content = this.node.querySelector(this.opts.content);
        this.initSlider();
    }

    initSlider() {
        // Wait for jQuery and DOM to be ready
        jQuery(document).ready(() => {
            // Initialize Slick slider
            jQuery(this.content).slick({
            	slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
                prevArrow: this.node.querySelector(this.opts.back),
                nextArrow: this.node.querySelector(this.opts.forward),
                dots: true,
                appendDots: this.node,
                customPaging: (slider, i) => `<button class="dot" data-slide="${i + 1}"></button>`,
	            centerPadding: '30px',
	            responsive: [
				    {
				      breakpoint: 781,
				      settings: {
				        slidesToShow: 1,
				        slidesToScroll: 1
				      }
				    }
				  ]
            });



            // Handle slick change event to update video play state
            jQuery(this.content).on('beforeChange', () => {
                this.pauseVideos();
            });
        });
    }

    pauseVideos() {
        const videoBlocks = this.node.querySelectorAll('.wp-block-wdg-video-block.wdg-video-block');
        videoBlocks.forEach(videoBlock => {
            const playButton = videoBlock.querySelector('.wdg-video-block__buttons--play');
            const video = videoBlock.querySelector('video');
            if (video && !video.paused) {
                video.pause();
                playButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53" fill="none"><circle cx="26" cy="26.4639" r="25" stroke="#F1B434" stroke-width="2"/><path d="M34 25.9625L22.5698 32.9875L22.5698 18.9375L34 25.9625Z" fill="white"/></svg> Play Video';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    jQuery(document).ready(() => {
        document.querySelectorAll('.media-slider-slick').forEach((node) => {
            new MediaSlickSlider(node, { ...node.dataset });
        });
    });
});
